import { ExportFormatType } from 'Common/Constants/Enumeration/ExportFormatType';

export const FileExtensions = {
  [ExportFormatType.Excel]: 'xls',
  [ExportFormatType.PortableDocFormat]: 'pdf',
  // [ExportFormatType.CharacterSeparatedValues]: 'csv',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/FileExtensions.js